<mat-card class="news-form-card">
  <mat-card-title style="text-align: center">{{ 'Edit Images & Files' | translate }}</mat-card-title>
  <mat-card-content>

    <div class="form-section image-upload-section">
      <div class="form-section">
        <h3>{{ 'Main Image' | translate }}</h3>

        <input style="margin-left: 17rem" type="file" accept="image/*" (change)="onMainImageChange($event)" />
        <div>
          <h4>{{ 'Preview' | translate }}</h4>
          <img *ngIf="mainImagePreviewUrl" [src]="mainImagePreviewUrl" alt="Main image" class="image-preview">
        </div>

        <div style="margin-top: 5rem">
          <h4>{{ 'Crop Image' | translate }}</h4>
          <image-cropper
            *ngIf="showCropper"
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="15 / 6"
            [imageQuality]="0.8"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()">
          </image-cropper>
          <button mat-button color="primary" (click)="saveCroppedImage()">
            {{ 'Save Cropped Image' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-section image-upload-section">
      <h3>{{ 'Upload Additional Images' | translate }}</h3>
      <input (change)="onAdditionalImagesChange($event)" accept="image/*" class="file-input" multiple
             style="margin-left: 17rem" type="file">
      <div class="additional-images-preview">
        <img *ngFor="let img of additionalImagePreviewUrls" [src]="img" alt="Additional image" class="image-preview">
      </div>
    </div>

    <div class="form-section image-upload-section">
      <h3>{{ 'Upload PDF Document' | translate }}</h3>
      <input
        (change)="onPdfChange($event)"
        accept="application/pdf"
        class="file-input"
        style="margin-left: 17rem"
        type="file"
      />

      <div *ngIf="pdfPreviewUrl">
        {{pdfFileName}}
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions class="submit-button-container">
    <button (click)="onSubmit()" color="primary" mat-raised-button>{{ 'Update Images & Files' | translate }}</button>
  </mat-card-actions>
</mat-card>
